import React from 'react';
import { Icon, InputFormField } from '../components';

const SearchForm = ({ id, label, className, searchContent, searchQuery, onSearchChange, disabled }) => (
  <form className={className} onSubmit={(e) => {
    if (searchContent) {
      searchContent(e);
    }
    else {
      e.preventDefault();
      e.stopPropagation();
    }
  }}>
    <InputFormField id={id} label={label} value={searchQuery || ''} onChange={onSearchChange} disabled={disabled} type='text-item search-item'>
      <Icon icon='search-large' />
    </InputFormField>
  </form>
);

export default SearchForm;


// WEBPACK FOOTER //
// ./src/containers/components/search-form.js